import { DashboardNavLinks } from 'components/organisms/DashboardNavLinks';
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';

import { Spacing, Breakpoints, Zindex } from 'constants/theme';

export const Menu: React.FC<{
  show?: boolean;
}> = ({ show }) => {
  useEffect(() => {
    const body = document.querySelector('body')!;
    if (show) {
      body.style.overflow = 'hidden';
    } else {
      body.style.removeProperty('overflow');
    }
  }, [show]);

  return (
    <MenuContainer $show={show} aria-hidden={!show}>
      <MenuItemsContainer>
        <DashboardNavLinks />
      </MenuItemsContainer>
    </MenuContainer>
  );
};

const MenuContainer = styled.aside<{ $show?: boolean }>`
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${Zindex.SideNav};
  display: block;
  margin-top: ${Spacing.l};
  ${({ $show }) =>
    $show
      ? css`
          opacity: 1;
          visibility: visible;
        `
      : css`
          opacity: 0;
          visibility: hidden;
        `};
  transition: visibility 0.3s, opacity 0.3s linear;
`;

const MenuItemsContainer = styled.div`
  position: relative;
  padding: ${Spacing.sm};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-width: ${`${Breakpoints.laptopL}px`};
  margin: auto;
`;
